import { render, staticRenderFns } from "./HeaderTab.vue?vue&type=template&id=1961f09c&scoped=true&"
import script from "./HeaderTab.vue?vue&type=script&lang=js&"
export * from "./HeaderTab.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTab.vue?vue&type=style&index=0&id=1961f09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961f09c",
  null
  
)

export default component.exports